import queryString from "query-string";
import axios from "axios";

import ApiConstants from "../constants/Api";
const { API_HOST } = ApiConstants;

const ConverterAPI = {
  /**
   * params: {
   *    from: String Ex: btcinr,
   *    to: String Ex: ethinr,
   *    amount: Number
   * }
   * response: {
   *    from_price: Number,
   *    to_price: Number,
   *    amount: Number,
   * }
   * */
  getConversionRate: (params) => {
    const queryParams = queryString.stringify({
      from: params.from,
      to: params.to,
      amount: params.amount,
    });
    return axios.get(`${API_HOST}/api/v2/crypto_converter?${queryParams}`);
  },
};

export default ConverterAPI;
